import Network from '@/services/network'
import {useQuery} from '../utils/query'
import {useCreateFormData} from './form-data/bill-pay/useFormData'
import {ToWords} from "to-words";

export default function handlePurchaseAndSales() {
    const network = new Network;
    const {allParams,getQueryString} = useQuery(20)
    const {formData, salesFormData, prepareFormData, prepareSalesFormData} = useCreateFormData()

    const fetchCurrencyList = (query) => {
        return network.api('get', '/currency/all'+query);
    }
    const fetchProductList = (query) => {
        return network.api('get', '/inventory/products/all'+query);
    }
    const fetchProductBySlug = (query) => {
        return network.api('get', '/inventory/products/by-slug'+query);
    }
    const fetchProductsForSpecifications = (query) => {
        return network.api('get', '/inventory/products/for/specifications'+query);
    }
    const fetchProducts = (query) => {
        return network.api('get', '/inventory/products/list'+query);
    }
    const fetchProductById = (productId, query) => {
        return network.api('get', `/inventory/products/${productId}/for/stock${query}`)
    }
    const fetchProductsById = (data) => {
        return network.api('post', `/inventory/products/products/stock`, data)
    }
    const fetchProductByProductId = (productId, query) => {
        return network.api('get', `/inventory/products/${productId}${query}`)
    }
    const fetchGroupProducts = (query) => {
        return network.api('get', '/inventory/products/group-list'+query);
    }
    const fetchAccountHead = (query) => {
        return network.api('get', '/account-heads'+query);
    }
    const fetchAccountPayable = (query) => {
        return network.api('get', '/inventory/accounts-payable'+query);
    }
    const fetchAccountReceivable = (query) => {
        return network.api('get', '/inventory/accounts-receivable'+query);
    }
    const fetchVatPayable = (query) => {
        return network.api('get', '/inventory/vat-payable'+query);
    }
    const updateBill = (purchaseMasterId, data) => {
        return network.api('put', `/inventory/purchases/bills/${purchaseMasterId}`, data);
    }
    const storeBill = (data) => {
        return network.api('post', '/inventory/purchases/bills', data);
    }
    const storeBillPayment = (data) => {
        return network.api('post', '/inventory/sales/invoices', data);
    }
    const fetchPurchaseList = (query) => {
        return network.api('get', `/inventory/purchases/bills${query ? query : getQueryString()}`);
    }
    const fetchPaymentStatus = (query) => {
        return network.api('get', `/inventory/purchases/payment-status` + query);
    }
    const fetchSalesList = (query) => {
        return network.api('get', `/inventory/sales/invoices${query ?? getQueryString()}`);
    }
    const fetchLatestSaleByIpd = (ipdRegisterId, query) => {
        return network.api('get', `/inventory/sales/invoices/latest-sale-by-ipd/${ipdRegisterId}` + query);
    }
    const fetchSalesRegisterList = (query) => {
        return network.api('get', `/inventory/sales/sales-register` + query);
    }
    const fetchDentalSalesRegisterList = (query) => {
        return network.api('get', `/inventory/sales/dental-sales-register` + query);
    }
    const fetchSalesOrderRegisterList = (query) => {
        return network.api('get', `/inventory/sales/order-register` + query);
    }
    const fetchDueList = (query) => {
        return network.api('get', 'inventory/purchases/payment/due'+query);
    }
    const fetchInvoiceDueList = (query) => {
        return network.api('get', 'inventory/sales/receipt/due'+query);
    }
    const storePayment = (data) => {
        return network.api('post', 'inventory/purchases/payment/create', data)
    }
    const storeAdvancePayment = (data) => {
        return network.api('post', 'inventory/purchases/payment/advance', data)
    }
    const storeTdsVdsPayment = (data) => {
        return network.api('post', 'inventory/purchases/payment-tds-vds/create', data)
    }
    const fetchTdsVdsPayment = (ledgerMasterId, query) => {
        return network.api('get', 'inventory/purchases/payment-tds-vds/show/' + ledgerMasterId + query)
    }
    const updateTdsVdsPayment = (ledgerMasterId, data) => {
        return network.api('put', 'inventory/purchases/payment-tds-vds/update/' + ledgerMasterId, data)
    }
    const storeInvoice = (data) => {
        return network.api('post', 'inventory/sales/receipt/create', data)
    }
    const storeAdvanceInvoice = (data) => {
        return network.api('post', 'inventory/sales/receipt/advance', data)
    }

    const fetchPurchaseBill = (purchaseMasterId, query = '') => {
        return network.api('get', `/inventory/purchases/bills/${purchaseMasterId}`+query);
    }

    const fetchSalesBill = (salesId, query = '') => {
        return network.api('get', `/inventory/sales/invoices/${salesId}`+query);
    }

    const fetchDentalSalesBill = (salesId, query = '') => {
        return network.api('get', `/inventory/sales/invoices/show-sale-master/${salesId}`+query);
    }

    const fetchInvoiceTemplateSalesBill = (salesId, query = '') => {
        return network.api('get', `/inventory/sales/invoices/template/${salesId}`+query);
    }

    const updateSalesBill = (salesId, data) => {
        return network.api('put', `/inventory/sales/invoices/${salesId}`, data);
    }
    const addPaymentKeyWithBill = (bills) => {
       return bills.map(bill => {
           bill.payment = ''
           return bill
       })
    }

    const fetchSinglePayment = (paymentId, query) => {
        return network.api('get', `/inventory/purchases/payment/${paymentId}` + query);
    }

    const updateBillPayment = (paymentMasterId, data) => {
        return network.api('put', `/inventory/purchases/payment/${paymentMasterId}`, data);
    }

    const fetchMoneyReceipt = (receiptId, query) => {
        return network.api('get', `/inventory/sales/receipt/${receiptId}` + query);
    }

    const updateMoneyReceipt = (receiptId, data) => {
        return network.api('put', `/inventory/sales/receipt/${receiptId}`, data);
    }

    const returnMoneyReceipt = (receiptId, data) => {
        return network.api('post', `/money-receipt/${receiptId}/return`, data);
    }

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: 2
        }).format(value);
    }

    const fetchProductStock = (productId, query) => {
        return network.api('get', `/inventory/products/${productId}/stock` + query);
    }

    const fetchBatchProductStock = (query) => {
        return network.api('get', `/inventory/products/stocks` + query);
    }

    const fetchSalesOrderList = (query) => {
        return network.api('get', `/inventory/sales/order${query}`)
    }

    const fetchSalesOrderInvoiceList = (query) => {
        return network.api('get', `/inventory/sales/order/invoice/list${query}`)
    }

    const fetchSalesGeneralList = (query, saleMasterId) => {
        return network.api('get', `/inventory/sales/sales-general/${saleMasterId}` + query)
    }

    const fetchSingleSalesGeneral = (query, id) => {
        return network.api('get', `/inventory/sales/single-sales-general/${id}` + query)
    }
    
    const fetchOrderStatus = (query) => {
        return network.api('get', `/inventory/sales/order-status${query}`)
    }

    const getEcommerceOrderStatusColumns = (query) => {
        return network.api('get', `/inventory/sales/ecommerce-orders/workflow-status${query}`)
    }

    const getEcommerceOrders = (query) => {
        return network.api('get', `/inventory/sales/ecommerce-orders${query}`)
    }

    const getEcommerceOrderActivity = (id, query) => {
        return network.api('get', `/inventory/sales/ecommerce-orders/${id}/activity${query}`)
    }

    const updateEcommerceOrderStatus = (id, data) => {
        return network.api('put', `/inventory/sales/ecommerce-orders/${id}/workflow-status`, data)
    }

    const updateEcommerceOrderTag = (id, data) => {
        return network.api('post', `/inventory/sales/ecommerce-orders/${id}/tag`, data)
    }

    const createSalesOrder = (data) => {
        return network.api('post', `/inventory/sales/order`, data)
    }

    const updateOrderStatus = (query, id) => {
        return network.api('put', `/inventory/sales/update-order-status/${id}` + query)
    }

    const updateSalesOrder = (id, data) => {
        return network.api('put', `/inventory/sales/order/${id}`, data)
    }

    const updateSalesOrderAttachment = (id, data) => {
        return network.api('post', `/inventory/sales/update-sales-order-attachment/${id}`, data)
    }

    const fetchSalesOrderById = (id, query) => {
        return network.api('get', `/inventory/sales/order/${id}${query}`)
    }

    const fetchSalesOrderTypes = (query) => {
        return network.api('get', `/inventory/sales/order/sale-types${query}`)
    }

    const fetchPendingProductInitiateList = (query) => {
        return network.api('get', `/inventory/sales/pending-project-initiate${query}`)
    }

    const updateProjectInitiateStatus = (id, data) => {
        return network.api('put', `/inventory/sales/project-initiate-status/${id}`, data)
    }

    const createDeliveryChallan = (data) => {
        return network.api('post', `/inventory/delivery-challan`, data)
    }

    const updateDeliveryChallan = (id, data) => {
        return network.api('put', `/inventory/delivery-challan/${id}`, data)
    }

    const fetchDeliveryChallanList = (query) => {
        return network.api('get', `/inventory/delivery-challan${query}`)
    }

    const fetchDeliveryChallan = (id, query) => {
        return network.api('get', `/inventory/delivery-challan/${id}${query}`)
    }

    const createInvoiceFromChallan = (data) => {
        return network.api('post', `/inventory/delivery-challan/invoice`, data)
    }

    const getAccountHeadBySlag = (slag, query) => {
        return network.api('get', `/inventory/accounts-by-slag/${slag}${query}`)
    }

    const currencyToWord = (value, currencyShow = true, ignoreZeroCurrency = false) => {
        const toWords = new ToWords({
            localeCode: 'en-BD',
            converterOptions: {
                currency: currencyShow,
                ignoreDecimal: false,
                ignoreZeroCurrency: ignoreZeroCurrency,
                doNotAddOnly: false,
            }
        });
        return toWords.convert(value);
    }

    //Ex: 123.45 One Hundred Twenty Three Point Four Five
    const currencyToDigitWord = (value) => {
        const toWords = new ToWords();
        const [integerPart, decimalPart] = value.toString().split('.');

        let words = toWords.convert(Number(integerPart));

        if (decimalPart && Number(decimalPart) !== 0) {
          const decimalWords = decimalPart
            .split('')
            .map((digit) => toWords.convert(Number(digit)))
            .join(' ');
        
          words += ` Point ${decimalWords}`;
        }
    
        return words;
    }

    const fetchSalesCommissionReportSummary = (query) => {
        return network.api('get', `/reports/sales-commission/summery${query}`)
    }

    const fetchSalesCommissionReportDetails = (query) => {
        return network.api('get', `/reports/sales-commission${query}`)
    }

    const fetchProductWithBatch = (query) => {
        return network.api('get', `/inventory/stock-register/product-list${query}`)
    }

    const fetchProductByStockId = (stockId, query) => {
        return network.api('get', `/inventory/stock-register/product-by-stock/${stockId}${query}`)
    }

    const fetchSalesOfferSetup = (query) => {
        return network.api('get', `/inventory/sales-offer-setup${query}`)
    }

    const storeSalesOfferSetup = (data) => {
        return network.api('post', '/inventory/sales-offer-setup', data);
    }

    const updateSalesOfferSetup = (itemId, data) => {
        return network.api('put', `/inventory/sales-offer-setup/${itemId}`, data);
    }

    const deleteSalesOfferSetup = (itemId, query) => {
        return network.api('delete', `/inventory/sales-offer-setup/${itemId}${query}`);
    }

    const fetchFreeQuantity = (productId, query) => {
        return network.api('get', `/inventory/sales-offer-setup/${productId}/get-free-quantity${query}`);
    }

    const fetchSaleOfferDiscount = (productId, query) => {
        return network.api('get', `/inventory/sales-offer-setup/${productId}/get-discount${query}`);
    }

    const fetchProductCostingList = (query) => {
        return network.api('get', `/inventory/product-costing${query}`)
    }
    const fetchProductCosting = (query) => {
        return network.api('get', '/inventory/product-costing/get-list' + query)
    }
    const storeProductCosting = (data) => {
        return network.api('post', '/inventory/product-costing', data);
    }
    const fetchSingleProductCosting = (masterId, query) => {
        return network.api('get', '/inventory/product-costing/' + masterId + query);
    }
    const fetchCostingProductType = (query) => {
        return network.api('get', '/inventory/product-costing/costing-product-types' + query);
    }
    const updateProductCosting = (masterId, data) => {
        return network.api('put', `/inventory/product-costing/${masterId}`, data);
    }
    const statusUpdateProductCosting = (masterId, data) => {
        return network.api('put', `/inventory/product-costing/status-update/${masterId}${data}`);
    }

    const fetchProductionList = (query) => {
        return network.api('get', `/inventory/productions${query}`)
    }
    const storeProduction = (data) => {
        return network.api('post', '/inventory/productions', data);
    }
    const fetchSingleProduction = (masterId, query) => {
        return network.api('get', '/inventory/productions/' + masterId + query);
    }

    const updateProductionDate = (id, data) => {
        return network.api('put', `/inventory/productions/update-date/${id}`, data);
    }

    const cacheProductQuantity = (data) => {
        return network.api('post', `/cache-available-quantity`, data);
    }

    const getProductsFormKey = (formKey, query) => {
        return network.api('get', `get/reserved-quantity/${formKey}${query}`);
    }

    const getFromKeysByUser = (query) => {
        return network.api('get', `get/form-keys-by-user/${query}`);
    }

    const removeProductsFormKey = (formKey, query) => {
        return network.api('delete', `remove-cache-available-quantity/${formKey}${query}`);
    }

    const fetchContactPurchaseAdvances = (contactId, query) => {
        return network.api('get', `/inventory/purchases/${contactId}/advance` + query);
    }

    return {
        fetchContactPurchaseAdvances,
        storeBill,
        fetchProductList,
        fetchProductBySlug,
        fetchProductsForSpecifications,
        fetchProducts,
        fetchProductById,
        fetchProductByProductId,
        fetchGroupProducts,
        fetchAccountHead,
        fetchAccountPayable,
        fetchAccountReceivable,
        fetchSalesOrderList,
        fetchSalesGeneralList,
        fetchSingleSalesGeneral,
        fetchOrderStatus,
        createSalesOrder,
        fetchPendingProductInitiateList,
        updateProjectInitiateStatus,
        fetchVatPayable,
        storeBillPayment,
        fetchSalesList,
        fetchLatestSaleByIpd,
        fetchSalesRegisterList,
        fetchDentalSalesRegisterList,
        fetchSalesOrderRegisterList,
        fetchPurchaseList,
        fetchPaymentStatus,
        fetchDueList,
        fetchInvoiceDueList,
        formData,
        salesFormData,
        storePayment,
        storeAdvancePayment,
        storeTdsVdsPayment,
        fetchTdsVdsPayment,
        updateTdsVdsPayment,
        storeInvoice,
        storeAdvanceInvoice,
        prepareFormData,
        prepareSalesFormData,
        addPaymentKeyWithBill,
        allParams,
        fetchPurchaseBill,
        updateBill,
        fetchSinglePayment,
        updateBillPayment,
        fetchMoneyReceipt,
        updateMoneyReceipt,
        returnMoneyReceipt,
        fetchSalesBill,
        fetchDentalSalesBill,
        fetchInvoiceTemplateSalesBill,
        updateSalesBill,
        formatCurrency,
        currencyToWord,
        currencyToDigitWord,
        fetchProductStock,
        fetchCurrencyList,
        updateSalesOrder,
        fetchSalesOrderById,
        fetchSalesOrderTypes,
        getEcommerceOrderStatusColumns,
        getEcommerceOrders,
        getEcommerceOrderActivity,
        updateEcommerceOrderStatus,
        updateEcommerceOrderTag,
        fetchProductByStockId,
        createInvoiceFromChallan,
        fetchDeliveryChallanList,
        createDeliveryChallan,
        updateDeliveryChallan,
        getAccountHeadBySlag,
        fetchDeliveryChallan,
        fetchProductWithBatch,
        fetchSalesCommissionReportSummary,
        fetchSalesCommissionReportDetails,
        fetchSalesOfferSetup,
        storeSalesOfferSetup,
        updateSalesOfferSetup,
        deleteSalesOfferSetup,
        fetchFreeQuantity,
        fetchSaleOfferDiscount,
        fetchProductCostingList,
        fetchProductCosting,
        storeProductCosting,
        fetchSingleProductCosting,
        fetchCostingProductType,
        updateProductCosting,
        statusUpdateProductCosting,
        storeProduction,
        fetchSingleProduction,
        fetchProductionList,
        fetchBatchProductStock,
        updateSalesOrderAttachment,
        updateOrderStatus,
        updateProductionDate,
        fetchSalesOrderInvoiceList,
        cacheProductQuantity,
        getProductsFormKey,
        getFromKeysByUser,
        removeProductsFormKey,
        fetchProductsById,
    }
}
